import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import _ from 'lodash';
import moment from 'moment/moment';
import Switch from 'react-switch';
import { searchWorkersForJobAction, clearWorkersPredictionsList, setWorkersPredictionsList } from '../../../../actions/users';
import { getWorkerQuickView, clearWorkerQuickView } from '../../../../actions/worker';
import { editJobWorkerAction, addJobWorkerAction } from '../../../../actions/jobWorkers';
import { getLanguagesList } from '../../../../actions';
import { getJobDetails } from '../../../../actions/jobs';
import { UIShowAlert, UIShowConfirm } from '../../../../actions/ui';
import { startSupportConversation, updateUnreadMessagesQuantity, updateUserConversationPreferences } from '../../../../actions/conversations';
import { getCompanyFavAndBlocks } from '../../../../actions/companies';
import { jobWorkerStatusSortingIndexes, jobWorkerHoursNeedApproval, jobWorkerStatus } from '../../../../constants/jobs';
import { confirmationMessages, alertMessages } from '../../../../constants/text';
import { favStatuses } from '../../../../constants/workers';
import { getHiredWorkers, shouldRateWorkers, isJobHasNotStarted, isJobEnded, isJobNotEditable, isJobSaved, isJobPosted,
  isJobFilled, getHiredWorkersQuantity } from '../../../../helpers/jobs';
import UserService from '../../../../services/UsersService';
import AddWorkerModal from '../../../common/ui/AddWorkerModal';
import Avatar from '../../../../components/common/ui/Avatar';
import Worker from './Worker';
import SignatureModal from './SignatureModal';
import TipsAndRates from '../TipsAndRates';
import QuickView from '../../../common/ui/QuickView/QuickView';
import WorkerQuickView from '../../../common/ui/QuickView/WorkerQuickView';
import FormActionButtons from '../../../common/forms/FormActionButtons';
import MessageHiredWorkers from './MessageHiredWorkers';
import Close from '../../../common/ui/Close';


class WorkersTab extends Component {
  static propTypes = {
    languages: PropTypes.array.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    jobDetails: PropTypes.object.isRequired,
    companyDetails: PropTypes.shape({
      favAndBlocks: PropTypes.array.isRequired
    }),
    isWorkerLoading: PropTypes.bool.isRequired,
    approveJob: PropTypes.func.isRequired,
    unApproveJob: PropTypes.func.isRequired,
    searchWorkersForJobAction: PropTypes.func.isRequired,
    setWorkersPredictionsList: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    getWorkerQuickView: PropTypes.func.isRequired,
    clearWorkerQuickView: PropTypes.func.isRequired,
    getLanguagesList: PropTypes.func.isRequired,
    updateUserConversationPreferences: PropTypes.func.isRequired,
    updateUnreadMessagesQuantity: PropTypes.func.isRequired,
    getCompanyFavAndBlocks: PropTypes.func.isRequired,
    editJobWorkerAction: PropTypes.func.isRequired,
    addJobWorkerAction: PropTypes.func.isRequired,
    getJobDetails: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      onlyHired: false,
      addWorkerModalIsOpen: false,
      signatureModalIsOpen: false,
      isMessageSending: false,
      isWorkerQuickViewOpen: false,
      isHoursAmountModalOpen: false,
      showRateModal: false
    };
  }

  componentDidMount () {
    if (!this.props.languages.length) {
      this.props.getLanguagesList();
    }
  }

  openHoursAmountModal = () => this.setState({ isHoursAmountModalOpen: true });

  closeHoursAmountModal = () => this.setState({ isHoursAmountModalOpen: false });

  getJobWorkersForApproval = () => getHiredWorkers(this.props.jobDetails.job_workers)
    .filter(job_worker => job_worker.actual_hours > jobWorkerHoursNeedApproval);

  handleChangeFilter = checked => {
    this.setState({ onlyHired: checked });
  };

  confirmHoursCorrect = event => {
    event.preventDefault();

    this.setState({ isHoursAmountModalOpen: false, signatureModalIsOpen: true });
  };

  approveHours = () => {
    const { job_workers } = this.props.jobDetails;
    const canApproveHours = job_workers && getHiredWorkers(job_workers).every(worker => {
      return !_.isNull(worker.actual_hours);
    });
    if (canApproveHours) {
      if (UserService.isAdmin()) {
        this.props.UIShowConfirm(confirmationMessages.approveJob, this.props.approveJob);
      } else {
        if (UserService.isEmployer() && this.getJobWorkersForApproval().length) {
          return this.openHoursAmountModal();
        }

        this.setState({
          signatureModalIsOpen: true
        });
      }
    } else {
      this.props.UIShowAlert(alertMessages.approveJobNoHours);
    }
  };

  unApproveHours = () => {
    const { UIShowConfirm, unApproveJob } = this.props;
    UIShowConfirm(confirmationMessages.unApproveJob, unApproveJob);
  };

  handleRateWorkersModal = () => {
    const { job_workers } = this.props.jobDetails;
    this.setState({ showRateModal: shouldRateWorkers(job_workers) });
  };

  submitJobApprovalEmployer = signatureUrl => {
    this.props.approveJob(signatureUrl)
      .then(() => this.closeSignatureModal())
      .then(this.handleRateWorkersModal);
  };

  addWorker = () => {
    this.setState({
      addWorkerModalIsOpen: true
    });
  };

  loadDefaultPredictionsList = () => {
    const { getCompanyFavAndBlocks, jobDetails: { id, is_lta, company_id, job_skill_id, start_date } } = this.props;
    if (!is_lta) {
      getCompanyFavAndBlocks({
        company_id: UserService.isAdmin() ? company_id : null,
        status: favStatuses.favorite,
        skill: job_skill_id,
        job_id: id,
        job_date: moment.utc(start_date).format()
      }).then(this.setWorkersPredictions);
    }
  };

  setWorkersPredictions = () => {
    this.props.setWorkersPredictionsList(this.props.companyDetails.favAndBlocks);
  };

  addWorkersSubmit = selectedWorkers => {
    const { addJobWorkerAction, getJobDetails, jobDetails: { id } } = this.props;
    // user_id we take from default workers predictions list with favorites (getCompanyFavAndBlocks)
    // if worker data is from searchWorkersForJob action - we take worker's id
    const actionPromises = [];
    selectedWorkers.forEach(worker => {
      const workerData = {
        job_id: id,
        user_id: worker.user_id || worker.id,
        status: jobWorkerStatus.OFFERED
      };
      actionPromises.push(addJobWorkerAction(workerData));
    });
    Promise.all(actionPromises).then(() => getJobDetails(id));
  };

  closeAddWorkerModal = () => {
    this.setState({
      addWorkerModalIsOpen: false
    });
  };

  closeSignatureModal = () => {
    this.setState({
      signatureModalIsOpen: false
    });
  };

  openWorkerQuickView = () => this.setState({ isWorkerQuickViewOpen: true });

  closeWorkerQuickView = () => {
    this.setState({ isWorkerQuickViewOpen: false });
    this.props.clearWorkerQuickView();
  };

  onWorkerQuickViewOpen = id => {
    this.openWorkerQuickView();
    this.props.getWorkerQuickView(id);
  };

  updateConversationMessagesCount = async (conversation_id, participant_id) => {
    const { updateUserConversationPreferences, updateUnreadMessagesQuantity } = this.props;
    await updateUserConversationPreferences(
      conversation_id,
      participant_id,
      {
        unread_count: 0
      }
    );
    return updateUnreadMessagesQuantity();
  };

  editJobWorker = (workerId, workerData) => {
    const { editJobWorkerAction, getJobDetails, jobDetails: { id } } = this.props;
    const jobWorkerData = {
      job_id: id,
      ...workerData
    };
    editJobWorkerAction(workerId, jobWorkerData).then(() => getJobDetails(id));
  };

  render () {
    const { onlyHired, addWorkerModalIsOpen, signatureModalIsOpen } = this.state;
    const { workersPredictionsList, searchWorkersForJobAction, clearWorkersPredictionsList, jobDetails } = this.props;
    const { id, quantity_of_workers, start_date, end_date, time_zone_id, status, is_approved, job_skill_id,
      skill_level_id, job_workers } = jobDetails;
    const compareWorkers = (a, b) => {
      const statusOrder = jobWorkerStatusSortingIndexes;
      const statusA = a.status;
      const statusB = b.status;
      const byStatus = (statusOrder[statusB] < statusOrder[statusA]) - (statusOrder[statusA] < statusOrder[statusB]);
      const byFirstName = (b.first_name < a.first_name) - (a.first_name < b.first_name);
      return byStatus || byFirstName;
    };
    let sortedWorkers = [];
    if (job_workers) {
      sortedWorkers = job_workers.sort(compareWorkers);
    }
    let hiredWorkers = null;
    if (job_workers) {
      hiredWorkers = getHiredWorkers(sortedWorkers);
    }
    let shownWorkers = null;
    if (onlyHired) {
      shownWorkers = hiredWorkers;
    } else {
      shownWorkers = sortedWorkers;
    }
    const jobStatusIsSaved = isJobSaved(status);
    const jobStatusIsPosted = isJobPosted(status);
    const jobStatusIsFilled = isJobFilled(status);
    const isAdmin = UserService.isAdmin();
    const hiredWorkersExist = hiredWorkers && hiredWorkers.length > 0;
    const jobIsNotEditable = isJobNotEditable(status, is_approved);
    const jobIsEnded = isJobEnded(end_date, time_zone_id);
    const canAddWorker = jobStatusIsPosted && !is_approved && (!jobIsEnded || isAdmin);
    const searchWorkerData = {
      job_skill_id,
      ranking_number: skill_level_id,
      job_id: id,
      job_date: moment.utc(start_date).format()
    };
    const jobHasNotStarted = isJobHasNotStarted(start_date, time_zone_id);
    const canApproveJob = !jobHasNotStarted && !is_approved && !jobStatusIsSaved && hiredWorkersExist;
    const canAddTips = !jobHasNotStarted && !is_approved && !jobStatusIsSaved && hiredWorkersExist;
    const canRateWorkers = UserService.isEmployer() && is_approved && !jobHasNotStarted && !jobStatusIsSaved && hiredWorkersExist;
    const allJobWorkersAreHired = job_workers && job_workers.length > 0 && !job_workers.find(worker => worker.status !== jobWorkerStatus.HIRED);
    return (
      <Fragment>
        <section className='workers-info'>
          <div className='table-row table-header flex-column flex-sm-row flex-nowrap flex-sm-wrap'>
            { hiredWorkersExist && !allJobWorkersAreHired && (
              <label className='d-flex align-items-center mr-sm-2 order-1 order-sm-0'>
                <span className='hired-label'>Hired</span>
                <Switch
                  onChange={this.handleChangeFilter}
                  checked={onlyHired}
                  onColor='#68ca59'
                  uncheckedIcon={false}
                  checkedIcon={false}
                  width={35}
                  height={19}
                />
              </label>
            )}
            { hiredWorkersExist && (
              <MessageHiredWorkers
                jobDetails={jobDetails}
                hiredWorkers={hiredWorkers}
                updateConversationMessagesCount={this.updateConversationMessagesCount}
              />
            )}
            <div className='quantity-info my-2'>
              <strong className='color-matched'>{getHiredWorkersQuantity(job_workers)} </strong>
              hired of
              <span className='needed'> {quantity_of_workers} </span>
              needed
            </div>
            <div className='d-flex flex-column flex-sm-row mx-sm-auto mx-lg-0 mt-sm-2'>
              { canAddWorker && (
                <button
                  className='button button-primary button-worker-action'
                  onClick={this.addWorker}
                >
                  Add worker +
                </button>
              )}
              { addWorkerModalIsOpen && (
                <AddWorkerModal
                  isOpen
                  closeModal={this.closeAddWorkerModal}
                  addWorkersSubmit={this.addWorkersSubmit}
                  workersPredictionsList={workersPredictionsList}
                  searchAction={searchWorkersForJobAction}
                  searchData={searchWorkerData}
                  setWorkersPredictions={this.setWorkersPredictions}
                  loadDefaultPredictionsList={this.loadDefaultPredictionsList}
                  clearWorkersPredictionsList={clearWorkersPredictionsList}
                />
              )}
              { canApproveJob && (
                <React.Fragment>
                  <button
                    className='button button-primary button-worker-action'
                    onClick={this.approveHours}
                  >
                    Approve Hours
                  </button>
                  <SignatureModal
                    isOpen={signatureModalIsOpen}
                    closeModal={this.closeSignatureModal}
                    submitJobApprovalEmployer={this.submitJobApprovalEmployer}
                    UIShowConfirm={this.props.UIShowConfirm}
                  />
                </React.Fragment>
              )}
              { is_approved && isAdmin && (
                <button
                  className='button button-primary button-worker-action'
                  onClick={this.unApproveHours}
                >
                  Unapprove Hours
                </button>
              )}
              { (canAddTips || canRateWorkers) && (
                <TipsAndRates
                  hiredWorkers={hiredWorkers}
                  job_id={id}
                  canAddTips={canAddTips}
                  canRateWorkers={canRateWorkers}
                  showRateModal={this.state.showRateModal}
                />
              )}
            </div>
          </div>
          { job_workers ? shownWorkers.map(worker => (
            <Worker
              key={worker.id}
              worker={worker}
              editJobWorker={this.editJobWorker}
              jobIsNotEditable={jobIsNotEditable}
              jobStartDate={start_date}
              jobEndDate={end_date}
              jobHasNotStarted={jobHasNotStarted}
              jobStatusIsFilled={jobStatusIsFilled}
              time_zone_id={time_zone_id}
              UIShowAlert={this.props.UIShowAlert}
              UIShowConfirm={this.props.UIShowConfirm}
              onQuickViewOpen={this.onWorkerQuickViewOpen}
            />
          )) : jobStatusIsSaved ? (
            <div className='table-row'>
              <p>Post the job and find workers</p>
            </div>
          ) : canAddWorker ? (
            <div className='table-row'>
              <p>There is no workers yet. Click Add worker to find.</p>
            </div>
          ) : null
          }
        </section>

        {UserService.isEmployer() && (
          <Modal isOpen={this.state.isHoursAmountModalOpen} centered>
            <form onSubmit={this.confirmHoursCorrect}>
              <div className='modal-header'>
                <div className='modal-title'>Please confirm hours are correct for:</div>
                <Close onClick={this.closeHoursAmountModal} />
              </div>
              <div className='modal-body'>
                <div className='form-group'>
                  {this.getJobWorkersForApproval().map(worker => (
                    <div className='form-group d-flex align-items-center' key={worker.id}>
                      <Avatar photo_image_url={worker.photo_image_url} />

                      <div>{worker.first_name} {worker.last_name}</div>

                      <strong className='ml-auto text-md'>
                        {worker.actual_hours}&nbsp;hrs
                      </strong>
                    </div>
                  ))}
                </div>

                <FormActionButtons
                  onClickCancel={this.closeHoursAmountModal}
                  submitTitle={'Approve'}
                />
              </div>
            </form>
          </Modal>
        )}

        <QuickView
          isActive={this.state.isWorkerQuickViewOpen}
          onClose={this.closeWorkerQuickView}
          isLoading={this.props.isWorkerLoading}
        >
          <WorkerQuickView updateConversationMessagesCount={this.updateConversationMessagesCount} />
        </QuickView>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    jobDetails: state.jobs.jobDetails,
    workersPredictionsList: state.users.workersPredictionsList,
    workerQuickView: state.worker.workerQuickView,
    isWorkerLoading: state.worker.isLoading,
    languages: state.languagesList,
    companyDetails: state.companies.companyDetails
  };
};

const mapDispatchToProps = {
  getJobDetails,
  searchWorkersForJobAction,
  setWorkersPredictionsList,
  clearWorkersPredictionsList,
  UIShowAlert,
  UIShowConfirm,
  getWorkerQuickView,
  clearWorkerQuickView,
  getLanguagesList,
  startSupportConversation,
  updateUserConversationPreferences,
  updateUnreadMessagesQuantity,
  getCompanyFavAndBlocks,
  editJobWorkerAction,
  addJobWorkerAction
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkersTab);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/index.js